module.exports = __webpack_public_path__ + "static/media/share.688acd60.png";